import * as Lo from 'lodash';
import { useCallback } from 'react';
import { generatePath, useLocation, useHistory } from 'react-router-dom';

import { HomePage } from 'pages';
import { commonRoutes, RouteType } from 'shared-pages/common/routes';
import {
  AlarmsGridPage,
  AlarmsPerCollectorRep,
  CollectedWeightByMaterialPage,
  CollectedWeightByMaterialByCollectorPage,
  CollectedWeightByMaterialByRegionPage,
  CollectedWeightByWasteDestinationPage,
  ContributionItemDetailsPage,
  ContributionItemsSumsPage,
  YearlyContributorsContributionsPage,
  YearlyEmpaContributionsPage,
} from 'shared-pages';

export const routes: RouteType[] = [
  ...commonRoutes, // <================ COMMON ROUTES
  { name: 'HomePage', path: '/', component: HomePage },
  // Εισφορές --------------------------------------
  {
    name: 'YearlyEmpaContributions',
    path: '/yearlyempacontributions',
    component: YearlyEmpaContributionsPage,
  },
  {
    name: 'ContributionItemsSums',
    path: '/contributionitemssums',
    component: ContributionItemsSumsPage,
  },
  {
    name: 'ContributionItemDetails',
    path: '/contributionitemdetails',
    component: ContributionItemDetailsPage,
  },
  {
    name: 'YearlyContributorsContributions',
    path: '/yearlycontributorscontributions',
    component: YearlyContributorsContributionsPage,
  },
  // Αναφορές συλλογών (Idoc Reports) --------------------------------------
  {
    name: 'CollectedWeightByMaterial',
    path: '/colbymat',
    component: CollectedWeightByMaterialPage,
  },
  {
    name: 'CollectedWeightByMaterialByCollector',
    path: '/colbymatbycollector',
    component: CollectedWeightByMaterialByCollectorPage,
  },
  {
    name: 'CollectedWeightByMaterialByRegion',
    path: '/colbymatbyregion',
    component: CollectedWeightByMaterialByRegionPage,
  },
  {
    name: 'CollectedWeightByWrecPoint',
    path: '/colbymatbywrecpoint',
    component: CollectedWeightByWasteDestinationPage,
  },
  {
    name: 'CollectedWeightByDa',
    path: '/colbymatbyda',
    component: CollectedWeightByWasteDestinationPage,
  },
  // Alarms --------------------------------------
  { name: 'Alarms', path: '/alarms', component: AlarmsGridPage },
  { name: 'AlarmsPerCollectorRep', path: '/alarms-rep-1', component: AlarmsPerCollectorRep },
];

export function getRouteByName(name: string): string {
  const idx = Lo.findIndex(routes, ['name', name]);
  if (idx === -1) return '/';
  return routes[idx].path;
}

export class Paths {
  static user = (id) => {
    return generatePath(getRouteByName('User'), { id: id });
  };
  static users = () => {
    return generatePath(getRouteByName('Users'));
  };
}

export function useNavigateTo() {
  const location = useLocation<any>();
  const history = useHistory();

  const navigateTo = useCallback<(path: string) => void>(
    (path) => {
      history.push({
        pathname: path,
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    },
    [history, location.pathname, location.state],
  );
  return navigateTo;
}
